module.exports = __webpack_public_path__ + "img/MobilyBrand.04f7d93c.svg";